import styled from "styled-components";
import { regularFont, labelColor, dangerColor } from "@app/styles";

type Props = {
  background?: string;
  setError?: boolean;
};

export const ProfileImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProfileImage = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  border-radius: 50%;
  overflow: hidden;
  z-index: 1;
  position: relative;
  background: linear-gradient(
    59.45deg,
    rgba(1, 107, 181, 0.15) 4.59%,
    rgba(132, 196, 69, 0.15) 96.63%
  );
  border: ${(props: Props) =>
    props.setError ? "2px solid #ED0000" : "2px solid #00BE9A"};
`;
export const SingleImage = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
  border-radius: 6px;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 1;
  position: relative;
  background-image: ${(props: Props) =>
    props.background ? "url(" + props.background + ")" : "none"};
  color: #00be9a;
  font-size: 60px;
  text-align: center;
  text-transform: capitalize;
  font-weight: 600;
`;
export const AddProfileDiv = styled.div`
  bottom: 0px;
  display: block;
  z-index: 9;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 0;
  right: 0;
  height: 30px;
  width: 100%;
`;
export const AddProfileText = styled.p`
  font-size: 11px;
  line-height: 18px;
  font-weight: 600;
  text-align: center;
  margin: 0 auto;
  span {
    font-weight: 600;
    padding-left: 5px;
  }
`;
export const AddProfileInput = styled.input`
  cursor: pointer;
  z-index: 5;
  position: absolute;
  top: 0px;
  opacity: 0;
  width: 100%;
  height: 100%;
  padding-left: 100%;
  left: 1px;
`;
export const ProgressBar = styled.div`
  margin: 0;
  bottom: 0;
  border-radius: 0;
  height: 5px;
  z-index: 26;
  background-color: transparent;
  overflow: hidden;
  position: absolute;
  left: 0;
  width: 100%;
`;
export const ProgreeBarInnner = styled.div`
  background-color: #00be9a;
  transition: width 0.6s ease;
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  animation: progress-bar-stripes 2s linear infinite;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  float: left;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
`;

export const ImageInstructions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px 0;
  span {
    font-size: 12px;
    ${regularFont};
    color: ${labelColor};
    padding-right: 12px;
    position: relative;
    &::after {
      content: "*";
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      color: ${dangerColor};
    }
  }
`;
